'use strict';

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsPopableAvatar = 
{
	template: `<img ng-src="https://www.gravatar.com/avatar/{{$ctrl.vm.gravatar}}?s=27&amp;d=mm" popover-placement="right" uib-popover-template="'avatarpopuptemplate.html'" popover-trigger="'mouseenter'">`,
	bindings: {
		vm: "<"
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function everlapsInscriptionExtraInfo() 
{
	return {
		restrict: 'A',
		require: '^ngModel',
		scope: {
			ngModel: '=',
		},
		template: `<button class="btn btn-xs btn-default" uib-popover-template="'extrainfopopup.html'" popover-placement="\'left\'">Info</button>`
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsCarNumber =
{
	template: 
	`<div style="position:relative; min-width:1.8em; max-width: 2.1em">
		<div style="position:absolute; top:0; left:0; width:100%; height:100%;">
			<div class="carnumberbackground" style="transform:skewX(170deg); width:100%; height:100%; border-collapse: collapse; -moz-border-radius: 0.3em; border-radius:0.3em; border: 0.08em solid;"></div>
		</div>
		<span style="position:relative; margin-left:0.2em; margin-right:0.2em">{{$ctrl.driver.carnumber}}<span>
	</div>`,
	bindings: {
		driver: "<"
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsDriverName =
{
	template: 
	`<a ui-sref="driverstats({event:{{$ctrl.event}}, race:{{$ctrl.race}}, driver:{{$ctrl.driver.driverid}} })">
		<span>{{$ctrl.driver.name}} {{$ctrl.driver.surname}}</span>
	</a>`,
	bindings: {
		driver: "<"
	},
	controller: function($stateParams) 
	{
		'ngInject';
		this.event = $stateParams.event;
		this.race = $stateParams.race;
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsDriverNameOptionalNick =
{
	template: 
	`<a ui-sref="driverstats({event:{{$ctrl.event}}, race:{{$ctrl.race}}, driver:{{$ctrl.driver.driverid}} })">
		<span>{{$ctrl.driver.name}} {{$ctrl.driver.surname}}
			<em class="hidden-sm hidden-xs text-muted">{{$ctrl.driver.nick}}</em>
		</span>
	</a>`,
	bindings: {
		driver: "<"
	},
	controller: function($stateParams) 
	{
		'ngInject';
		this.event = $stateParams.event;
		this.race = $stateParams.race;
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsDriverNick =
{
	template: 
	`<a ui-sref="driverstats({event:{{$ctrl.event}}, race:{{$ctrl.race}}, driver:{{$ctrl.driver.driverid}} })">
		<span>
			<em class="text-muted">{{$ctrl.driver.nick}}</em>
		</span>
	</a>`,
	bindings: {
		driver: "<"
	},
	controller: function($stateParams) 
	{
		'ngInject';
		this.event = $stateParams.event;
		this.race = $stateParams.race;
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsDriverAnnotations =
{
	template:
	`<ul>
		<li ng-repeat="d in $ctrl.drivers | filter: { annotations: [] }">
			<everlaps-driver-name driver="d"></everlaps-driver-name>
			<span ng-repeat="a in d.annotations">{{a.annotation}}{{$last ? "" : "&nbsp;|&nbsp;"}}</span>
		</li>
	</ul>`,
	bindings: {
		drivers: "<"
	},
	controller: function($stateParams) 
	{
		'ngInject';
		this.event = $stateParams.event;
		this.race = $stateParams.race;
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsFromToDate =
{
	template: `<span>{{'DATE_FROM' | translate}} {{$ctrl.from | amDateFormat:'LL'}} {{'DATE_TO' | translate}} {{$ctrl.to | amDateFormat:'LL'}}</span>`,
	bindings: {
		from: "<",
		to: "<"
	}
}


// WEBPACK FOOTER //
// ./client/app/app.filters.js